module.exports = __webpack_public_path__ + "img/screen_1.83481b93.svg";